const desktopNav = () => {
    const selectors = {
        desktopNav: '[data-desktop-nav]',
        desktopNavLink: '[data-desktop-nav-link]',
        closeIcon: '[data-mega-menu-close]',
    };
    const classes = {
        active: 'link--active',
    };
    const desktopNav = document.querySelector(selectors.desktopNav);
    const desktopNavLinks = desktopNav === null || desktopNav === void 0 ? void 0 : desktopNav.querySelectorAll(selectors.desktopNavLink);
    desktopNavLinks === null || desktopNavLinks === void 0 ? void 0 : desktopNavLinks.forEach((desktopNavLink) => {
        const closeIcon = desktopNavLink.querySelector(selectors.closeIcon);
        const toggleActiveClass = (event) => {
            if (event.target == desktopNavLink) {
                desktopNavLinks === null || desktopNavLinks === void 0 ? void 0 : desktopNavLinks.forEach((link) => {
                    link.classList.remove(classes.active);
                });
            }
            if (event.type == 'click') {
                desktopNavLink.classList.add(classes.active);
            }
            if (event.type == 'click' && event.target == closeIcon) {
                desktopNavLink.classList.remove(classes.active);
            }
        };
        desktopNavLink.addEventListener('click', toggleActiveClass);
        desktopNavLink.addEventListener('mouseover', toggleActiveClass);
    });
};
export { desktopNav };
